<ion-card>
  <ion-card-content>
    <div class="service-data">
      <img loading="lazy" class="service-icon" src="{{ service.image }}" alt="{{ service.name }}">
      <h5 class="service-title">{{ service.name }}</h5>
    </div>

    <div class="service-desc" innerHTML="{{ service.description }}">
    </div>
  </ion-card-content>
</ion-card>